import { forwardRef } from 'react';
import type { SVGProps, Ref } from 'react';
type Props = SVGProps<SVGSVGElement>;
/**
 * @public
 */
const SvgPhoneCall = forwardRef((props: Props, svgRef: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1.5em"
    height="1.5em"
    fill="none"
    viewBox="0 0 24 24"
    ref={svgRef}
    {...props}
  >
    <path
      fill="currentColor"
      d="M13.25 3.25a.75.75 0 000 1.5c2.9 0 5.25 2.35 5.25 5.25a.75.75 0 001.5 0 6.75 6.75 0 00-6.75-6.75z"
    />
    <path
      fill="currentColor"
      d="M13.25 6.25a.75.75 0 000 1.5A2.25 2.25 0 0115.5 10a.75.75 0 001.5 0 3.75 3.75 0 00-3.75-3.75z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8.605 4.553C8.241 4.193 7.797 4 7.33 4c-.467 0-.917.194-1.294.555l-.608.61-.757.77a2.695 2.695 0 00-.655 1.558c-.073.882.104 1.714.461 2.674.581 1.56 1.448 3 2.731 4.537a16.785 16.785 0 005.593 4.36c1.173.553 2.12.862 3.164.929l.075.003.157.004c.855 0 1.577-.308 2.14-.916.128-.156.26-.293.452-.481l.344-.332c.107-.103.203-.2.296-.296.372-.386.571-.84.571-1.31 0-.476-.204-.928-.584-1.303l-1.943-1.941c-.368-.382-.816-.586-1.29-.586-.472 0-.923.202-1.304.581l-1.044 1.036c-.303-.211-1.215-.95-1.937-1.616l-.296-.279c-.857-.83-1.832-1.984-2.079-2.384.11-.103.225-.212.35-.336l.698-.702c.795-.792.795-1.834 0-2.625l-.967-.963-.624-.634a13.044 13.044 0 00-.375-.36zM7.16 5.563a.308.308 0 01.17-.063c.048 0 .103.02.17.074l.174.161.243.237.629.638.966.963c.207.205.207.294 0 .5l-.694.698-.217.21-.4.371a1 1 0 00-.17 1.257l.215.35c.348.565 1.434 1.824 2.311 2.675a28.264 28.264 0 002.3 1.962l.46.323a1 1 0 001.28-.109l1.339-1.33c.112-.111.188-.145.247-.145.052 0 .116.029.211.127l1.961 1.96c.112.11.145.184.145.242 0 .065-.038.153-.15.269l-.191.193-.548.532c-.169.169-.299.31-.43.468-.221.236-.542.374-.984.374l-.16-.006-.19-.015c-.695-.073-1.412-.303-2.406-.772a15.273 15.273 0 01-5.085-3.97c-1.175-1.406-1.954-2.7-2.473-4.094-.311-.834-.42-1.437-.372-2.026a1.2 1.2 0 01.37-.78l1.217-1.224.062-.05z"
      clipRule="evenodd"
    />
  </svg>
));
SvgPhoneCall.defaultProps = {
  'aria-hidden': true,
  focusable: 'false',
  role: 'img',
};
export default SvgPhoneCall;
